import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { Lead } from 'src/app/models/Lead';

@Injectable({
    providedIn: 'root'
})
export class LeadApi extends Api<Lead> {
}
